import Vue from 'vue'
import VueProgressiveImage from 'vue-progressive-image'
import App from './App.vue'
// import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import './misc/register-service-worker'
import './misc/handle-network-status'
import './firebase/init'
import './firebase/authentication'
import './misc/handle-apple-install-prompt'
import 'pwacompat'
import i18n from './i18n'

Vue.config.productionTip = false
Vue.use(VueProgressiveImage)

new Vue({
  vuetify,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

console.log(`
Welcome to Saga Dashboard
🇮🇪 Made with ❤️ & 🍺in Ireland 🇮🇪
👉 https://sagadash.com/

`)
